<div fxLayout="row" fxLayoutAlign="space-between center">
  <span class="error" *ngIf="control.invalid && (control.touched || control.dirty)">{{
    errorMsg
  }}</span>
</div>
